import type { PointWithdrawalStatus, PointWithdrawalType } from "@/types/PointWithdrawal";
import { pointsToYen } from "@/utils/pointsToYen";
import { format } from "date-fns";
import { ja } from "date-fns/locale";
import type React from "react";
import { Icon } from "../../components/Icons/Icon";
import { PaymentHeading } from "../Withdrawal";
import { PaymentIconSrc } from "../Withdrawal/Payment/Confirmation";

const WITHDRAWAL_STATUS_CONFIG: Record<PointWithdrawalStatus, { text: string; bgColor: string }> = {
  Success: { text: "出金完了", bgColor: "bg-disabled" },
  Cancelled: { text: "キャンセル", bgColor: "bg-red" },
  Pending: { text: "出金処理中", bgColor: "bg-primary" },
};

interface RecordCard {
  record: {
    id: string;
    type: PointWithdrawalType;
    status: PointWithdrawalStatus;
    updatedAt: number;
    redeemablePoints: string;
    email: string;
  };
}

export const RecordCard: React.FC<RecordCard> = ({ record }) => {
  return (
    <div className="flex flex-col items-start gap-2 w-full pb-3 border-b border-[#ECECEC] border-solid">
      <div className="flex items-center justify-start gap-2 w-full">
        <div
          className={`${WITHDRAWAL_STATUS_CONFIG[record.status].bgColor} px-[9px] py-[5px] w-[103px] flex items-center justify-center`}
        >
          <p className="font-bold text-sm text-white">{WITHDRAWAL_STATUS_CONFIG[record.status].text}</p>
        </div>

        <div className="flex items-center gap-1">
          <p className="text-xs font-semibold -tracking-[.01em] text-gray">
            {format(new Date(record.updatedAt), "yyyy年M月d日 H:mm", { locale: ja })}
          </p>
        </div>
      </div>

      <div className="flex items-center justify-start gap-2 w-full">
        <div className="h-[50px] w-[50px]">
          <Icon
            className="w-full h-full"
            src={PaymentIconSrc[record.type as keyof typeof PaymentIconSrc]}
            imageSize={{ width: "50", height: "50" }}
          />
        </div>
        <p className="text-lg font-bold">{PaymentHeading[record.type as keyof typeof PaymentHeading]}</p>
        <p className="text-lg font-bold -tracking-[.01em]">{pointsToYen(record.redeemablePoints)}円分</p>
      </div>

      <div className="flex flex-col sm:flex-row items-end gap-2 w-full">
        <div className="flex items-center gap-1 whitespace-nowrap min-w-0">
          <p className="text-[10px] font-semibold -tracking-[.01em] text-gray">注文ID</p>
          <p className="text-[10px] font-semibold -tracking-[.01em] text-gray">:</p>
          <p className="text-[10px] font-semibold -tracking-[.01em] text-gray truncate">{record.id}</p>
        </div>
        <div className="flex items-center gap-1 whitespace-nowrap">
          <p className="text-[10px] font-semibold -tracking-[.01em] text-gray">出金先</p>
          <p className="text-[10px] font-semibold -tracking-[.01em] text-gray">:</p>
          <p className="text-[10px] font-semibold -tracking-[.01em] text-gray">{record.email}</p>
        </div>
      </div>
    </div>
  );
};
